import React from "react";

export function PendingCheckIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 6V10L13 13M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
        stroke="#E9DB94"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function DisapprovedCheckIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM10 8.586L12.828 5.757L14.243 7.172L11.414 10L14.243 12.828L12.828 14.243L10 11.414L7.172 14.243L5.757 12.828L8.586 10L5.757 7.172L7.172 5.757L10 8.586Z"
        fill="#DA7777"
      />
    </svg>
  );
}

export function ApproveCheckIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 10L9 12L13 8M19 10C19 11.1819 18.7672 12.3522 18.3149 13.4442C17.8626 14.5361 17.1997 15.5282 16.364 16.364C15.5282 17.1997 14.5361 17.8626 13.4442 18.3149C12.3522 18.7672 11.1819 19 10 19C8.8181 19 7.64778 18.7672 6.55585 18.3149C5.46392 17.8626 4.47177 17.1997 3.63604 16.364C2.80031 15.5282 2.13738 14.5361 1.68508 13.4442C1.23279 12.3522 1 11.1819 1 10C1 7.61305 1.94821 5.32387 3.63604 3.63604C5.32387 1.94821 7.61305 1 10 1C12.3869 1 14.6761 1.94821 16.364 3.63604C18.0518 5.32387 19 7.61305 19 10Z"
        stroke="#85CC8B"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function NoSelectedItemIcon() {
  return (
    <svg
      width="73"
      height="73"
      viewBox="0 0 73 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="72.75" height="72.75" rx="36.375" fill="#ECF4FE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.2598 25.2891H26.0514L23.5254 30.3462V46.7604C23.5254 47.0954 23.6585 47.4167 23.8953 47.6535C24.1322 47.8904 24.4534 48.0235 24.7884 48.0235H47.5228C47.8578 48.0235 48.179 47.8904 48.4159 47.6535C48.6527 47.4167 48.7858 47.0954 48.7858 46.7604V30.3412L46.2598 25.2891ZM44.6987 27.8151L45.9617 30.3412H26.3508L27.6138 27.8151H44.6987ZM36.6832 41.3432H35.339V41.2383C35.3471 39.7851 35.7588 39.337 36.4733 38.893C36.9618 38.5862 37.3372 38.1987 37.3372 37.6335C37.3372 36.9998 36.8407 36.588 36.2231 36.588C35.6539 36.588 35.1049 36.9513 35.0686 37.7102H33.6315C33.6719 36.1763 34.8183 35.3932 36.2311 35.3932C37.7731 35.3932 38.8348 36.249 38.8348 37.6134C38.8348 38.5377 38.3706 39.1432 37.6278 39.5873C36.9698 39.9909 36.6913 40.3825 36.6832 41.2383V41.3432ZM36.9335 42.974C36.9295 43.4665 36.5218 43.8621 36.0454 43.8621C35.553 43.8621 35.1533 43.4665 35.1574 42.974C35.1533 42.4896 35.553 42.094 36.0454 42.094C36.5218 42.094 36.9295 42.4896 36.9335 42.974Z"
        fill="#2463AE"
      />
    </svg>
  );
}

export function SummaryChartIconUp(props) {
  return (
    <svg
      width="18"
      height="11"
      viewBox="0 0 18 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.2665 0.516667C17.1819 0.313042 17.0201 0.151229 16.8165 0.0666666C16.7163 0.0239658 16.6087 0.00131666 16.4998 0H12.3331C12.1121 0 11.9001 0.0877975 11.7439 0.244078C11.5876 0.400358 11.4998 0.61232 11.4998 0.833333C11.4998 1.05435 11.5876 1.26631 11.7439 1.42259C11.9001 1.57887 12.1121 1.66667 12.3331 1.66667H14.4915L9.83312 6.325L7.09145 3.575C7.01398 3.49689 6.92182 3.4349 6.82027 3.39259C6.71872 3.35028 6.6098 3.3285 6.49979 3.3285C6.38978 3.3285 6.28086 3.35028 6.17931 3.39259C6.07776 3.4349 5.98559 3.49689 5.90812 3.575L0.90812 8.575C0.830013 8.65247 0.768017 8.74464 0.72571 8.84619C0.683403 8.94774 0.661621 9.05666 0.661621 9.16667C0.661621 9.27668 0.683403 9.3856 0.72571 9.48715C0.768017 9.5887 0.830013 9.68086 0.90812 9.75833C0.985589 9.83644 1.07776 9.89844 1.17931 9.94074C1.28086 9.98305 1.38978 10.0048 1.49979 10.0048C1.6098 10.0048 1.71872 9.98305 1.82027 9.94074C1.92182 9.89844 2.01398 9.83644 2.09145 9.75833L6.49979 5.34167L9.24145 8.09167C9.31892 8.16977 9.41109 8.23177 9.51264 8.27408C9.61419 8.31638 9.72311 8.33817 9.83312 8.33817C9.94313 8.33817 10.0521 8.31638 10.1536 8.27408C10.2551 8.23177 10.3473 8.16977 10.4248 8.09167L15.6665 2.84167V5C15.6665 5.22101 15.7543 5.43298 15.9105 5.58926C16.0668 5.74554 16.2788 5.83333 16.4998 5.83333C16.7208 5.83333 16.9328 5.74554 17.089 5.58926C17.2453 5.43298 17.3331 5.22101 17.3331 5V0.833333C17.3318 0.724436 17.3092 0.616852 17.2665 0.516667Z"
        fill="#21D589"
      />
    </svg>
  );
}

export function SummaryCloseIcon(props) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20 21.1782L24.125 25.3032L25.3033 24.1249L21.1783 19.9999L25.3033 15.8749L24.125 14.6966L20 18.8216L15.875 14.6966L14.6967 15.8749L18.8217 19.9999L14.6967 24.1249L15.875 25.3032L20 21.1782Z"
        fill="#94A3B8"
      />
      <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="#E2E8F0" />
    </svg>
  );
}

export function ApproveBlueModalIcon(props) {
  return (
    <svg
      {...props}
      width="57"
      height="56"
      viewBox="0 0 57 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 2.63014C14.5 1.17755 15.6572 0 17.0846 0H43.4692L49.3385 6.0274L56.5 13.2055V53.3699C56.5 54.8224 55.3428 56 53.9154 56H17.0846C15.6572 56 14.5 54.8224 14.5 53.3699V2.63014Z"
        fill="#CFE4FC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8311 21.7533C19.8311 20.8152 20.5784 20.0547 21.5003 20.0547H46.3772C47.2991 20.0547 48.0464 20.8152 48.0464 21.7533C48.0464 22.6914 47.2991 23.4519 46.3772 23.4519H21.5003C20.5784 23.4519 19.8311 22.6914 19.8311 21.7533Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8311 31.7816C19.8311 30.8435 20.5784 30.083 21.5003 30.083H46.3772C47.2991 30.083 48.0464 30.8435 48.0464 31.7816C48.0464 32.7198 47.2991 33.4803 46.3772 33.4803H21.5003C20.5784 33.4803 19.8311 32.7198 19.8311 31.7816Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8311 41.8085C19.8311 40.8704 20.5784 40.1099 21.5003 40.1099H46.3772C47.2991 40.1099 48.0464 40.8704 48.0464 41.8085C48.0464 42.7466 47.2991 43.5071 46.3772 43.5071H21.5003C20.5784 43.5071 19.8311 42.7466 19.8311 41.8085Z"
        fill="white"
      />
      <path
        d="M56.4985 13.2055L43.4678 0V10.6192C43.4678 12.0761 44.6315 13.2554 46.0631 13.2494L56.4985 13.2055Z"
        fill="#94A3B8"
      />
      <circle cx="15.5" cy="41" r="15" fill="#2463AE" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0519 36.4494C22.6373 37.0485 22.6373 38.02 22.0519 38.6191L14.7711 46.0712C14.1857 46.6703 13.2366 46.6703 12.6512 46.0712L9.43905 42.7835C8.85365 42.1843 8.85365 41.2129 9.43905 40.6138C10.0244 40.0146 10.9736 40.0146 11.559 40.6138L13.7111 42.8165L19.932 36.4494C20.5174 35.8502 21.4665 35.8502 22.0519 36.4494Z"
        fill="#F4F7FA"
      />
    </svg>
  );
}

export const ExcelIcon = ({ color, size }) => {
  return (
    <svg
      style={{
        width: `${size ? size : 24}px`,
        height: `${size ? size : 24}px`,
      }}
      viewBox="0 0 24 24"
    >
      <path
        fill={color ? color : "currentColor"}
        d="M21.17 3.25Q21.5 3.25 21.76 3.5 22 3.74 22 4.08V19.92Q22 20.26 21.76 20.5 21.5 20.75 21.17 20.75H7.83Q7.5 20.75 7.24 20.5 7 20.26 7 19.92V17H2.83Q2.5 17 2.24 16.76 2 16.5 2 16.17V7.83Q2 7.5 2.24 7.24 2.5 7 2.83 7H7V4.08Q7 3.74 7.24 3.5 7.5 3.25 7.83 3.25M7 13.06L8.18 15.28H9.97L8 12.06L9.93 8.89H8.22L7.13 10.9L7.09 10.96L7.06 11.03Q6.8 10.5 6.5 9.96 6.25 9.43 5.97 8.89H4.16L6.05 12.08L4 15.28H5.78M13.88 19.5V17H8.25V19.5M13.88 15.75V12.63H12V15.75M13.88 11.38V8.25H12V11.38M13.88 7V4.5H8.25V7M20.75 19.5V17H15.13V19.5M20.75 15.75V12.63H15.13V15.75M20.75 11.38V8.25H15.13V11.38M20.75 7V4.5H15.13V7Z"
      />
    </svg>
  );
};

export const PDFIcon = ({ color, size }) => {
  return (
    <svg
      style={{
        width: `${size ? size : 24}px`,
        height: `${size ? size : 24}px`,
      }}
      viewBox="0 0 24 24"
    >
      <path
        fill={color ? color : "currentColor"}
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M9.5 11.5C9.5 12.3 8.8 13 8 13H7V15H5.5V9H8C8.8 9 9.5 9.7 9.5 10.5V11.5M14.5 13.5C14.5 14.3 13.8 15 13 15H10.5V9H13C13.8 9 14.5 9.7 14.5 10.5V13.5M18.5 10.5H17V11.5H18.5V13H17V15H15.5V9H18.5V10.5M12 10.5H13V13.5H12V10.5M7 10.5H8V11.5H7V10.5Z"
      />
    </svg>
  );
};

export function ExportIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.875 7.8125L16.8744 3.12562L12.1875 3.125"
        stroke="#0F172A"
        stroke-width="1.5"
        stroke-linecap="square"
        stroke-linejoin="round"
      />
      <path
        d="M11.2478 8.75244L16.8728 3.12744"
        stroke="#0F172A"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.375 11.25V16.25C14.375 16.4158 14.3092 16.5747 14.1919 16.6919C14.0747 16.8092 13.9158 16.875 13.75 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V6.25C3.125 6.08424 3.19085 5.92527 3.30806 5.80806C3.42527 5.69085 3.58424 5.625 3.75 5.625H8.75"
        stroke="#0F172A"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export const ImportIcon = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.71875 8.59461L10 11.875L13.2812 8.59461"
        stroke={color ? color : "#2463AE"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 3.125V11.8727"
        stroke={color ? color : "#2463AE"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.875 11.875V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875"
        stroke={color ? color : "#2463AE"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const NotificationIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.26904 9.75C5.2678 8.86051 5.44262 7.97957 5.78343 7.15796C6.12424 6.33635 6.6243 5.59031 7.25477 4.96286C7.88525 4.33541 8.63368 3.83895 9.45693 3.5021C10.2802 3.16525 11.1619 2.99467 12.0514 3.00019C15.7629 3.02778 18.7317 6.11282 18.7317 9.83474V10.5C18.7317 13.8577 19.4342 15.8062 20.0529 16.8711C20.1196 16.9849 20.1551 17.1142 20.1558 17.2461C20.1565 17.378 20.1224 17.5077 20.0569 17.6222C19.9915 17.7367 19.897 17.8319 19.7831 17.8982C19.6691 17.9646 19.5397 17.9997 19.4078 18H4.59222C4.46034 17.9997 4.33087 17.9645 4.21689 17.8982C4.1029 17.8318 4.00844 17.7366 3.94301 17.6221C3.87759 17.5076 3.84352 17.3778 3.84425 17.2459C3.84498 17.1141 3.88048 16.9847 3.94716 16.8709C4.56622 15.806 5.26904 13.8575 5.26904 10.5L5.26904 9.75Z"
        stroke="#0A4A95"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 18V18.75C9 19.5456 9.31607 20.3087 9.87868 20.8713C10.4413 21.4339 11.2044 21.75 12 21.75C12.7956 21.75 13.5587 21.4339 14.1213 20.8713C14.6839 20.3087 15 19.5456 15 18.75V18"
        stroke="#0A4A95"
        stroke-width="1.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const DownArrowIcon = ({ color }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={color ? color : "none"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.1667 7.64166C14.0106 7.48646 13.7994 7.39934 13.5792 7.39934C13.3591 7.39934 13.1478 7.48646 12.9917 7.64166L10 10.5917L7.05004 7.64166C6.8939 7.48646 6.68269 7.39934 6.46254 7.39934C6.24238 7.39934 6.03117 7.48646 5.87504 7.64166C5.79693 7.71913 5.73494 7.8113 5.69263 7.91285C5.65032 8.0144 5.62854 8.12332 5.62854 8.23333C5.62854 8.34334 5.65032 8.45226 5.69263 8.55381C5.73494 8.65536 5.79693 8.74753 5.87504 8.825L9.40837 12.3583C9.48584 12.4364 9.57801 12.4984 9.67956 12.5407C9.78111 12.583 9.89003 12.6048 10 12.6048C10.11 12.6048 10.219 12.583 10.3205 12.5407C10.4221 12.4984 10.5142 12.4364 10.5917 12.3583L14.1667 8.825C14.2448 8.74753 14.3068 8.65536 14.3491 8.55381C14.3914 8.45226 14.4132 8.34334 14.4132 8.23333C14.4132 8.12332 14.3914 8.0144 14.3491 7.91285C14.3068 7.8113 14.2448 7.71913 14.1667 7.64166Z"
        fill={color ? color : "#0A4A95"}
      />
    </svg>
  );
};

export const LeftArrowIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.828 12L15.778 16.95L14.364 18.364L7.99995 12L14.364 5.636L15.778 7.05L10.828 12Z"
        fill="#0F172A"
      />
    </svg>
  );
};

export const RightArrowIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.172 12L8.22205 7.05L9.63605 5.636L16 12L9.63605 18.364L8.22205 16.95L13.172 12Z"
        fill="#0F172A"
      />
    </svg>
  );
};

export const CachedIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5917 11.925H11.8167C11.5957 11.925 11.3837 12.0128 11.2274 12.1691C11.0712 12.3253 10.9834 12.5373 10.9834 12.7583C10.9834 12.9793 11.0712 13.1913 11.2274 13.3476C11.3837 13.5039 11.5957 13.5917 11.8167 13.5917H13.8167C12.8975 14.5523 11.712 15.2161 10.4127 15.4978C9.11329 15.7796 7.75936 15.6663 6.52483 15.1727C5.29031 14.6791 4.23158 13.8276 3.48468 12.7276C2.73778 11.6277 2.33683 10.3295 2.33335 8.99999C2.33335 8.77898 2.24556 8.56702 2.08928 8.41073C1.933 8.25445 1.72103 8.16666 1.50002 8.16666C1.27901 8.16666 1.06704 8.25445 0.910765 8.41073C0.754484 8.56702 0.666687 8.77898 0.666687 8.99999C0.671093 10.6273 1.15187 12.2178 2.04969 13.575C2.94751 14.9323 4.22308 15.997 5.71897 16.6377C7.21487 17.2784 8.86563 17.4671 10.4675 17.1805C12.0694 16.8939 13.5524 16.1446 14.7334 15.025V16.5C14.7334 16.721 14.8212 16.933 14.9774 17.0892C15.1337 17.2455 15.3457 17.3333 15.5667 17.3333C15.7877 17.3333 15.9997 17.2455 16.1559 17.0892C16.3122 16.933 16.4 16.721 16.4 16.5V12.75C16.398 12.5347 16.3127 12.3285 16.162 12.1747C16.0113 12.0209 15.8069 11.9314 15.5917 11.925ZM9.00002 0.666656C6.86368 0.67275 4.81126 1.49908 3.26669 2.97499V1.49999C3.26669 1.27898 3.17889 1.06701 3.02261 0.910734C2.86633 0.754454 2.65437 0.666656 2.43335 0.666656C2.21234 0.666656 2.00038 0.754454 1.8441 0.910734C1.68782 1.06701 1.60002 1.27898 1.60002 1.49999V5.24999C1.60002 5.471 1.68782 5.68297 1.8441 5.83925C2.00038 5.99553 2.21234 6.08332 2.43335 6.08332H6.18335C6.40437 6.08332 6.61633 5.99553 6.77261 5.83925C6.92889 5.68297 7.01669 5.471 7.01669 5.24999C7.01669 5.02898 6.92889 4.81701 6.77261 4.66073C6.61633 4.50445 6.40437 4.41666 6.18335 4.41666H4.18335C5.10208 3.45655 6.28676 2.79291 7.58535 2.51091C8.88394 2.22892 10.2372 2.34144 11.4714 2.83404C12.7055 3.32664 13.7644 4.17683 14.5119 5.27549C15.2594 6.37415 15.6616 7.67114 15.6667 8.99999C15.6667 9.221 15.7545 9.43297 15.9108 9.58925C16.067 9.74553 16.279 9.83332 16.5 9.83332C16.721 9.83332 16.933 9.74553 17.0893 9.58925C17.2456 9.43297 17.3334 9.221 17.3334 8.99999C17.3334 7.90564 17.1178 6.82201 16.699 5.81096C16.2802 4.79991 15.6664 3.88125 14.8926 3.10743C14.1188 2.33361 13.2001 1.71978 12.189 1.30099C11.178 0.882205 10.0944 0.666656 9.00002 0.666656Z"
        fill="#2463AE"
      />
    </svg>
  );
};

export const UpDownArrows = () => {
  return (
    <svg
      width="8"
      height="13"
      viewBox="0 0 8 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.09168 4.50832L4.00001 2.59166L5.90835 4.50832C5.98582 4.58643 6.07798 4.64843 6.17953 4.69073C6.28108 4.73304 6.39 4.75482 6.50001 4.75482C6.61002 4.75482 6.71894 4.73304 6.82049 4.69073C6.92204 4.64843 7.01421 4.58643 7.09168 4.50832C7.16979 4.43085 7.23178 4.33869 7.27409 4.23714C7.3164 4.13559 7.33818 4.02667 7.33818 3.91666C7.33818 3.80665 7.3164 3.69773 7.27409 3.59618C7.23178 3.49463 7.16979 3.40246 7.09168 3.32499L4.59168 0.82499C4.51421 0.746883 4.42204 0.684888 4.32049 0.642581C4.21894 0.600273 4.11002 0.578491 4.00001 0.578491C3.89 0.578491 3.78108 0.600273 3.67953 0.642581C3.57798 0.684888 3.48582 0.746883 3.40835 0.82499L0.908345 3.32499C0.751426 3.48191 0.663269 3.69474 0.663269 3.91666C0.663269 4.13857 0.751426 4.3514 0.908345 4.50832C1.06527 4.66524 1.27809 4.7534 1.50001 4.7534C1.72193 4.7534 1.93476 4.66524 2.09168 4.50832ZM5.90835 8.32499L4.00001 10.2417L2.09168 8.32499C2.01398 8.24729 1.92174 8.18566 1.82022 8.14361C1.7187 8.10156 1.60989 8.07991 1.50001 8.07991C1.39013 8.07991 1.28132 8.10156 1.1798 8.14361C1.07829 8.18566 0.986044 8.24729 0.908345 8.32499C0.830647 8.40269 0.769012 8.49493 0.726962 8.59645C0.684912 8.69797 0.663269 8.80677 0.663269 8.91666C0.663269 9.02654 0.684912 9.13535 0.726962 9.23686C0.769012 9.33838 0.830647 9.43062 0.908345 9.50832L3.40835 12.0083C3.48582 12.0864 3.57798 12.1484 3.67953 12.1907C3.78108 12.233 3.89 12.2548 4.00001 12.2548C4.11002 12.2548 4.21894 12.233 4.32049 12.1907C4.42204 12.1484 4.51421 12.0864 4.59168 12.0083L7.09168 9.50832C7.2486 9.3514 7.33676 9.13857 7.33676 8.91666C7.33676 8.69474 7.2486 8.48191 7.09168 8.32499C6.93476 8.16807 6.72193 8.07991 6.50001 8.07991C6.27809 8.07991 6.06527 8.16807 5.90835 8.32499Z"
        fill="#334155"
      />
    </svg>
  );
};

export const HorizontalDots = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_4534_184838)">
        <path
          d="M10 2.5C9.08337 2.5 8.33337 3.25 8.33337 4.16667C8.33337 5.08333 9.08337 5.83333 10 5.83333C10.9167 5.83333 11.6667 5.08333 11.6667 4.16667C11.6667 3.25 10.9167 2.5 10 2.5ZM10 14.1667C9.08337 14.1667 8.33337 14.9167 8.33337 15.8333C8.33337 16.75 9.08337 17.5 10 17.5C10.9167 17.5 11.6667 16.75 11.6667 15.8333C11.6667 14.9167 10.9167 14.1667 10 14.1667ZM10 8.33333C9.08337 8.33333 8.33337 9.08333 8.33337 10C8.33337 10.9167 9.08337 11.6667 10 11.6667C10.9167 11.6667 11.6667 10.9167 11.6667 10C11.6667 9.08333 10.9167 8.33333 10 8.33333Z"
          fill="#0F172A"
        />
      </g>
      <defs>
        <clipPath id="clip0_4534_184838">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NormalDot = ({ color }) => {
  return (
    <svg
      width="6"
      height="6"
      viewBox="0 0 6 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="3" cy="3" r="3" fill={color ? color : "#2463AE"} />
    </svg>
  );
};

export const BithdayDesign = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 5.5V4"
        stroke="#0F172A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99996 4C10.8888 3 7.99996 0.5 7.99996 0.5C7.99996 0.5 4.99996 3 7.99996 4Z"
        stroke="#0F172A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.125 7.875C10.125 8.43859 9.90112 8.97909 9.5026 9.3776C9.10409 9.77612 8.56359 10 8 10C7.43641 10 6.89591 9.77612 6.4974 9.3776C6.09888 8.97909 5.875 8.43859 5.875 7.875"
        stroke="#0F172A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.875 7.875C5.875 8.43141 5.65677 8.96562 5.26718 9.36288C4.8776 9.76014 4.34774 9.98875 3.79144 9.9996C2.60012 10.0224 1.625 9.02456 1.625 7.83303V7C1.625 6.60218 1.78304 6.22064 2.06434 5.93934C2.34564 5.65804 2.72718 5.5 3.125 5.5H12.875C13.2728 5.5 13.6544 5.65804 13.9357 5.93934C14.217 6.22064 14.375 6.60218 14.375 7V7.83303C14.375 9.02456 13.3999 10.0224 12.2086 9.9996C11.6523 9.98875 11.1224 9.76014 10.7328 9.36288C10.3432 8.96562 10.125 8.43141 10.125 7.875"
        stroke="#0F172A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.5 9.57935V13C13.5 13.1326 13.4473 13.2598 13.3536 13.3536C13.2598 13.4473 13.1326 13.5 13 13.5H3C2.86739 13.5 2.74021 13.4473 2.64645 13.3536C2.55268 13.2598 2.5 13.1326 2.5 13V9.57936"
        stroke="#0F172A"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CloudIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill={color ? color : "#000"}
      viewBox="0 0 24 24"
    >
      <title>cloud-check-variant</title>
      <path d="M10.35 17L16 11.35L14.55 9.9L10.33 14.13L8.23 12.03L6.8 13.45M6.5 20Q4.22 20 2.61 18.43 1 16.85 1 14.58 1 12.63 2.17 11.1 3.35 9.57 5.25 9.15 5.88 6.85 7.75 5.43 9.63 4 12 4 14.93 4 16.96 6.04 19 8.07 19 11 20.73 11.2 21.86 12.5 23 13.78 23 15.5 23 17.38 21.69 18.69 20.38 20 18.5 20Z" />
    </svg>
  );
};
